import createPullRequest from './create-pr/create-pr';
import requestViewFix from './request-view-fix/request-view-fix-service';
import getViewFix from './get-view-fix/get-view-fix-service';
import { pullRequestClient } from '../../api/clients';

const prService = {
  requestViewFix: requestViewFix(pullRequestClient),
  getViewFix: getViewFix(pullRequestClient),
  createPullRequest: createPullRequest(pullRequestClient),
};

export default prService;
